import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spinner } from '../spinner';
import IconSvg from '../icons';
import { Button as ButtonComponent } from '../../ui/button';
import { forwardRef } from 'react';
import { cn } from '../../../lib/utils';
import { CustomTooltip } from '../tooltip';
import { splitTooltipWrapperClasses } from './tooltip-wrapper-classes';
const ButtonForwardRef = forwardRef(({ loading, disabled, iconName, iconColor = 'currentColor', onClick, ...props }, ref) => {
    return (_jsx(ButtonComponent, { ref: ref, ...props, disabled: loading || disabled, onClick: (e) => {
            e.stopPropagation();
            onClick?.(e);
        }, children: _jsxs(_Fragment, { children: [loading && (_jsx("span", { className: 'mx-2', children: _jsx(Spinner, { className: "h-4! w-4!" }) })), iconName && _jsx(IconSvg, { name: iconName, iconColor: iconColor }), props.children] }) }));
});
ButtonForwardRef.displayName = 'Button';
export function Button({ tooltip, tooltipClassName, children, type = 'button', ...buttonProps }) {
    if (!tooltip) {
        return (_jsx(ButtonForwardRef, { type: type, ...buttonProps, children: children }));
    }
    // Con un tooltip il bottone sta SEMPRE dentro lo stesso span, trigger del
    // tooltip: se lo span comparisse solo da disabilitato, ogni cambio di
    // `disabled`/`loading` rimonterebbe il bottone (focus perso). Un bottone
    // disabilitato non riceve né puntatore né focus, quindi in quel caso lo
    // span diventa focusabile e il motivo del blocco resta leggibile anche da
    // tastiera; abilitato, il focus del bottone risale allo span e apre il
    // tooltip. Radix descrive lo span, quindi il bottone porta il testo del
    // tooltip come `aria-description` (salvo una descrizione del chiamante).
    const isBlocked = Boolean(buttonProps.loading || buttonProps.disabled);
    const classes = splitTooltipWrapperClasses(buttonProps.className);
    return (_jsx(CustomTooltip, { trigger: _jsx("span", { className: cn('inline-flex', classes.wrapper), tabIndex: isBlocked ? 0 : undefined, "data-slot": "button-tooltip-trigger", children: _jsx(ButtonForwardRef, { type: type, ...buttonProps, className: classes.button, "aria-description": buttonProps['aria-describedby'] ? undefined : tooltip, children: children }) }), content: tooltip, className: tooltipClassName }));
}
//# sourceMappingURL=index.js.map